/**
 * 5度电 滚动跑帧动效
 */
export default class FiveKwhScrollTrigger {
	constructor(id) {
		this.idName = id;
		this.$selector = $(`${id}`);
		this.scrollImg = {
			firstImg: '',
			bgTotal: 10,
			bgUrl: 'https://cdn.shopify.com/s/files/1/0550/0524/9633/files/',
			namePrefix: '',
			bgFormat: '',
			urlParam: 'v=1718590034',
			fps: 24,
			canvasDOM: '',
			pageScrollH: ''
		}

		this.hasWheelEventFired = false; // 鼠标滚动监听事件标识
		this.scrollDelta = 120; // 鼠标滚动间距

		// 所有配图路径
		this.urls = [];

		this.init();
	}

	init() {
		this.initWheelDelta();
		this.initData();
		this.scrollTriggerEvent();
	}
	/**
	 * 鼠标滚轮监听，获取鼠标滚动距离
	 */
	initWheelDelta() {
		const self = this;
		$(document).on('mousewheel DOMMouseScroll', function (event) {
			if (!self.hasWheelEventFired) {
				var delta = 0;
				if (event.originalEvent.wheelDelta) {
					delta = event.originalEvent.wheelDelta;
				} else if (event.originalEvent.detail) {
					delta = -event.originalEvent.detail;
				}
				self.scrollDelta = Math.abs(delta);
				self.hasWheelEventFired = true;
			}
		});
	}

	initData() {
		// 获取背景图路径相关数据
		this.scrollImg.firstImg = this.$selector.data('first-pc-img');
		this.scrollImg.namePrefix = this.$selector.data('pc-img-name-prefix') || 'solar-mars-bot-kv-pc-';
		this.scrollImg.bgTotal = this.$selector.data('pc-img-total') || 10;
		this.scrollImg.bgFormat = this.$selector.data('pc-img-format') || '.png';
		this.scrollImg.canvasDOM = `${this.idName} .pc-img-sequence`;
		this.scrollImg.fps = this.$selector.data('pc-fps') || 24;
		this.scrollImg.pageScrollH = this.scrollImg.bgTotal * (this.scrollDelta * 24 / this.scrollImg.fps);

		if (window.innerWidth < 1024) {
			this.scrollImg.firstImg = this.$selector.data('first-mb-img');
			this.scrollImg.namePrefix = this.$selector.data('mb-img-name-prefix') || 'solar-mars-bot-kv-mb-';
			this.scrollImg.bgTotal = this.$selector.data('mb-img-total') || 10;
			this.scrollImg.bgFormat = this.$selector.data('mb-img-format') || '.png';
			this.scrollImg.urlParam = 'v=1718590129';
			this.scrollImg.canvasDOM = `${this.idName} .mb-img-sequence`;
			this.scrollImg.fps = this.$selector.data('mb-fps') || 24;
			this.scrollImg.pageScrollH = this.scrollImg.bgTotal * (this.scrollDelta * 24 / this.scrollImg.fps);
		}
		if (this.scrollImg.firstImg && this.scrollImg.firstImg.indexOf('/shopify/assets/no-image-') === -1) {
			this.scrollImg.bgUrl = this.scrollImg.firstImg.split(this.scrollImg.namePrefix)[0];
			this.scrollImg.urlParam = this.scrollImg.firstImg.split('?')[1];
		}
	}

	// 加载默认图片
	loadDefaultImg() {
		const self = this;
		const $bgImg = this.$selector.find('.bg-img');
		const $bgImgSource = $bgImg.siblings('source');
		const mbImg = $bgImg.data('src');
		const pcImg = $bgImgSource.data('srcset');
		$bgImg.attr('src', mbImg);
		$bgImgSource.attr('srcset', pcImg);

		// 初始化Canvas宽高
		if (self.scrollImg.firstImg && self.scrollImg.firstImg.indexOf('/shopify/assets/no-image-') === -1) {
			const bgImg = this.$selector.find('.bg-img')[0];
			bgImg.addEventListener('load', function () {
				const pcSequence = self.$selector.find('.pc-img-sequence')[0];
				const mbSequence = self.$selector.find('.mb-img-sequence')[0];
				if (window.innerWidth < 1024) {
					// 规定 750*100
					mbSequence.width = bgImg.naturalWidth;
					mbSequence.height = bgImg.naturalHeight;
				} else {
					// 规定 1920*680
					pcSequence.width = bgImg.naturalWidth;
					pcSequence.height = bgImg.naturalHeight;
				}
			});
		}
	}

	// 获取Section中所有配图
	loadSectionImg() {
		const self = this;
		self.urls = new Array(self.scrollImg.bgTotal).fill()
			.map((o, i) => {
				let num = i + 1;
				let numStr = num.toString();
				if (num < 10) {
					numStr = `0${num}`
				}
				return `${self.scrollImg.bgUrl}${self.scrollImg.namePrefix}${numStr}${self.scrollImg.bgFormat}?${self.scrollImg.urlParam}`
			});
	}

	/*
	辅助函数，用于通过一系列图像进行擦洗，并将适当的图像绘制到提供的画布上。
	配置对象属性：
	- urls [数组]：图像 URL 的数组
	- canvas [画布]：用于绘制的 <canvas> 对象
	- clear [布尔值]：如果为 true，在绘制每一帧之前会清除画布（如果您的图像包含透明度，这很有用）
	- onUpdate [函数]：Tween 更新时的可选回调（可能不常用）。它将传递两个参数：1）图像的索引（基于零），2）绘制到画布上的图像
	*/
	imageSequence(config) {
		const self = this;
		const { urls: currUrls, clear, onUpdate: currOnUpdate, canvas: currCanvas } = config;
		let playHead = { frame: 0 };
		let canvas = window.gsap.utils.toArray(currCanvas)[0] || console.warn("canvas not defined");
		let ctx = canvas.getContext("2d");
		let curFrame = -1;
		let onUpdate = currOnUpdate;
		let images = [];

		function updateImage() {
			let frame = Math.min(Math.ceil(playHead.frame), self.scrollImg.bgTotal - 1);
			if (frame !== curFrame && images[frame] && images[frame].complete) {
				// 仅在必要时绘制新图片 或 图片已加载或加载完成
				clear && ctx.clearRect(0, 0, canvas.width, canvas.height);
				ctx.drawImage(images[frame], 0, 0);
				curFrame = frame;
				onUpdate && onUpdate.call(this, frame, images[frame]);
			}
		}

		images = currUrls.map((url, i) => {
			let img = new Image();
			img.src = url;
			i || (img.onload = updateImage);
			return img;
		});

		// 依据playHead中的frame，从0到 length-1(当前为40)逐渐变化进行补间动画
		return window.gsap.to(playHead, {
			frame: images.length - 1,
			ease: "none",
			onUpdate: updateImage,
			duration: images.length / (config.fps || 24),
			paused: !!config.paused,
			scrollTrigger: config.scrollTrigger,
		});
	}

	scrollTriggerEvent() {
		const self = this;
		window.gsap.registerPlugin(window.ScrollTrigger);

		// 没有配图，就不渲染
		if (this.scrollImg.bgTotal === 0) {
			return
		}

		// 滚动触发top值
		let startTop;

		// Header高度获取
		let headerH = document.querySelector('jky-header,header-v5,.site-header').offsetHeight;
		if ($('.header-after-sales').length > 0) {
			headerH = headerH + $('.header-after-sales').height();
		}
		if ($('.product-tabs-box,.section-navigation').length > 0) {
			startTop = $('.product-tabs-box,.section-navigation').height();
		} else {
			startTop = headerH;
		}


		let startVal;

		if(window.innerWidth < 1024){
			// 移动端 帧图盒子高度适配，保持铺满全屏
			startVal = `top ${startTop}`;
		$('.five-kwh-scroll-trigger .scroll-trigger-box').css('height', `calc(100vh - ${startTop}px)`);
		} else {
			// PC端 垂直居中
			const centerTopVal = (window.innerHeight - $(self.idName).height()) / 2;
			if (centerTopVal < startTop) {
				startVal = `top ${startTop}`;
			} else {
				startVal = `top ${centerTopVal}`;
			}
		}

		// 储存实例动画已经进行了多长的时间
		let tl;
		const time = tl ? tl.time() : 0;
		if (tl) {
			tl.kill();
		}

		// 加载图片
		this.loadDefaultImg();
		this.loadSectionImg();
		tl = this.imageSequence({
			urls: self.urls, // 图片 URL 数组
			canvas: self.scrollImg.canvasDOM, // 要绘制图像的 <canvas> 对象
			clear: true, // 仅在您的图像包含透明度时才有必要
			fps: self.scrollImg.fps,
			// onUpdate: (index, image) => console.log(self.idName,"draw image index1", index, ", image:", image),
			scrollTrigger: {
				trigger: self.idName,
				pin: true,
				start: startVal, // 从顶部开始
				end: `+=${self.scrollImg.pageScrollH}`,
				scrub: 0.5, // 平滑擦洗，需要 0.5 秒钟来“赶上”滚动条
				stagger: 0.1,
				snap: 0.1,
				// markers: true,
				ease: "none"
			},
		});
		tl.time(time);
	}
}
